module.exports = __webpack_public_path__ + "img/1488.fad24e95.gif";